import { useState, useEffect } from "react";

export interface ScreenLayout {
  isUltraWide: boolean;
  isSuperUltraWide: boolean;
  isDualUltraWide: boolean;
  isVertical: boolean;
  layoutHint: "standard" | "wide" | "ultra-wide" | "vertical";
  width: number;
  height: number;
}

export function useScreenLayout(): ScreenLayout {
  const [layout, setLayout] = useState<ScreenLayout>(() => computeLayout());

  useEffect(() => {
    const mql = [
      window.matchMedia("(min-width: 2560px)"),
      window.matchMedia("(min-width: 3440px)"),
      window.matchMedia("(min-width: 5120px)"),
      window.matchMedia("(orientation: portrait)"),
    ];

    function update() {
      setLayout(computeLayout());
    }

    for (const m of mql) {
      m.addEventListener("change", update);
    }
    window.addEventListener("resize", update);

    return () => {
      for (const m of mql) {
        m.removeEventListener("change", update);
      }
      window.removeEventListener("resize", update);
    };
  }, []);

  return layout;
}

function computeLayout(): ScreenLayout {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const isVertical = height > width * 1.3;
  const isUltraWide = width >= 2560;
  const isSuperUltraWide = width >= 3440;
  const isDualUltraWide = width >= 5120;

  let layoutHint: ScreenLayout["layoutHint"] = "standard";
  if (isVertical) layoutHint = "vertical";
  else if (isDualUltraWide) layoutHint = "ultra-wide";
  else if (isUltraWide) layoutHint = "wide";

  return { isUltraWide, isSuperUltraWide, isDualUltraWide, isVertical, layoutHint, width, height };
}
